
import ForgottenPasswordLink from '~/components/molecules/auth/ForgottenPasswordLink'

export default {
  components: { ForgottenPasswordLink },

  props: {
    callbackNewWindow: {
      type: Boolean,
      default: false,
    },
    callbackRoute: {
      type: [Object, String],
      default: undefined,
    },
  },

  data() {
    return {
      form: {
        fields: {
          email: '',
          password: '',
        },
      },
    }
  },

  methods: {
    /**
     * Try to authenticate user.
     */
    async handleSubmit() {
      let popup

      try {
        if (this.callbackNewWindow && this.callbackRoute) {
          popup = window.open(
            '',
            '_blank',
            'width=800,height=600,scrollbars=yes,resizable=yes,popup'
          )
        }

        await this.$auth.loginWith('api', { data: this.form.fields })

        if (popup && !popup.closed) {
          const url =
            typeof this.callbackRoute === 'string'
              ? this.callbackRoute
              : this.$router.resolve(this.callbackRoute).href
          popup.location.href = url
        }

        if (this.callbackRoute && !popup) {
          return this.$router.push(this.callbackRoute)
        }
      } catch (error) {
        if ([401, 403, 500].includes(error.response?.status)) {
          // status 500 is an expected use case!
          this.$notify({
            message: this.$t('error.auth.invalid_credentials'),
            type: 'error',
          })
        } else {
          this.$notify({ error })
        }

        if (popup && !popup.closed) {
          popup.close()
        }
      }
    },
  },
}
